import React from 'react';
import styled from 'styled-components';

const GuideBox = (props) => {
    return (
        <>
            <Box>
                <p>연애능력검사 결과를 알려드릴게요! <span>{props.order}/2</span></p>
            </Box>
        </>        
    );
};

const Box = styled.div`
    color: #3b3f42;
    font-size: 15px;
    letter-spacing: -0.45px;
    font-weight: 700;
    margin-top: 64px;
    span {
        margin-left: 5px;
        font-weight: bold;
    }
`;

export default GuideBox;